const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

/**
 * Renders emotes in text by replacing :emotename: with actual emote images or emoji
 * @param {string} text - The text containing :emotename: patterns
 * @param {Array} globalEmotes - Array of global emote objects
 * @param {Array} customEmotes - Array of custom emote objects
 * @returns {string} - HTML string with emote images
 */
export const renderEmotesInText = (text, globalEmotes = [], customEmotes = []) => {
  if (!text) return text;
  
  // Combine all available emotes
  const allEmotes = [...globalEmotes, ...customEmotes];
  
  let renderedText = text;
  
  // First, replace URLs with clickable links
  const urlPattern = /(https?:\/\/[^\s]+)/g;
  renderedText = renderedText.replace(urlPattern, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-cyan-400 hover:text-cyan-300 underline">${url}</a>`;
  });
  
  // Then replace each :emotename: with corresponding image or emoji
  allEmotes.forEach(emote => {
    const pattern = new RegExp(`:${emote.name}:`, 'g');
    
    // If it's a global emoji-based emote, render as emoji
    if (emote.emoji) {
      renderedText = renderedText.replace(
        pattern, 
        `<span class="inline-emote" style="font-size: 1.5em; vertical-align: middle;">${emote.emoji}</span>`
      );
    } 
    // Otherwise render as image
    else {
      renderedText = renderedText.replace(
        pattern,
        `<img src="${BACKEND_URL}/api${emote.file_path_28}" alt=":${emote.name}:" class="inline-emote" style="display: inline; width: 28px; height: 28px; vertical-align: middle; margin: 0 2px;" />`
      );
    }
  });
  
  return renderedText;
};

/**
 * React component helper to render emotes safely with dangerouslySetInnerHTML
 * @param {string} text - The text containing :emotename: patterns
 * @param {Array} globalEmotes - Array of global emote objects
 * @param {Array} customEmotes - Array of custom emote objects
 * @returns {Object} - Object with __html property for dangerouslySetInnerHTML
 */
export const createEmoteHTML = (text, globalEmotes = [], customEmotes = []) => {
  return {
    __html: renderEmotesInText(text, globalEmotes, customEmotes)
  };
};

export default {
  renderEmotesInText,
  createEmoteHTML
};
